import { PageBase } from 'frontend/common-imports'
import Logger from 'lib/logger'
import MediaQuery from 'lib/media-query'
import VideoTeaser from 'frontend/lib/video-teaser'

export default class RoomsPage extends PageBase {
  // detects free space in rooms list
  static handleMediaChange ({ name: mediaName, includes: mediaIncludes }) {
    this.handleRoomsList({ mediaName, mediaIncludes })
  }

  static handleRoomsList ({ mediaName, mediaIncludes }) {
    const rowSize = mediaIncludes.includes('xlarge') ? 3 : 2
    if (rowSize == this.lastProcessedRowSize) return

    const roomsList = document.querySelector('.rooms_list')

    if (!roomsList) {
      Logger.error('RoomsPage.handleMediaChange()', 'no .rooms_list element found')
      return
    }
    const roomsInList = roomsList.querySelectorAll('.room').length - 1 // - stub element

    if (roomsInList <= 0) {
      Logger.error('RoomsPage.handleMediaChange()', 'can\'t detect count of rooms in list')
      return
    }

    Logger.debug('RoomsPage.handleMediaChange()', `mediaName: ${mediaName} rowSize: ${rowSize}`)

    for (const stripeElement of roomsList.querySelectorAll('.stripe')) {
      this.relocateStripeBanner(stripeElement, rowSize, roomsList)
    }

    this.handleFreeSpace(roomsInList, rowSize, roomsList)
    this.lastProcessedRowSize = rowSize
  }

  static handleFreeSpace (roomsInList, rowSize, roomsList) {
    let freeSpace = false
    freeSpace = roomsInList % rowSize !== 0

    if (freeSpace) {
      Logger.info('RoomsPage.handleMediaChange()', 'free space detected')
      roomsList.classList.add('free_space')
    } else {
      Logger.info('RoomsPage.handleMediaChange()', 'no free space detected')
      roomsList.classList.remove('free_space')
    }
  }

  static relocateStripeBanner (stripe, rowSize, roomsList) {
    const stripePositionLine = parseInt(stripe.dataset.rowPosition)

    if (isNaN(stripePositionLine) || stripePositionLine < 1) {
      Logger.error('RoomsPage.relocateStripeBanner()', 'check data-row-position attribute')
      return
    }

    stripe?.remove()
    const prevElIndex = rowSize * stripePositionLine - 1
    const roomSlot = roomsList.querySelectorAll('.rooms_list > .room')[prevElIndex]

    if (!roomSlot) {
      Logger.info('RoomsPage.relocateStripeBanner()', 'no row found to place stripe banner')
      return
    }

    roomSlot.insertAdjacentElement('afterend', stripe)
    stripe.style.display = 'block'
    Logger.info('RoomsPage.relocateStripeBanner()', 'placed .stripe after element after index: ' + prevElIndex)
  }

  static handleDOMReady () {
    MediaQuery.addListener(this.handleMediaChange.bind(this))
    // this.handleMediaChange(MediaQuery.current)
  }

  static handleStylesApplied () {
    VideoTeaser.init({
      selector: '.rooms_list .room.has_video_teaser',
      offsetElements: { top: document.getElementById('layout_header') },
      columnsPerMedia: {
        small: 2,
        medium: 2,
        large: 2,
        xlarge: 3,
        xxlarge: 3,
      },
    })
  }
}

RoomsPage.init()
